<template>
  <div class="date-range-picker-container">
    <date-range-picker
      ref="picker"
      :maxSpan="{ 'days': 1 }"
      :dateRange="dateRange"
      :locale-data="locale"
      :autoApply="false"
      :ranges="false"
      @update="updateValues">
      <template v-slot:input>
        <div class="input-range-picke-container">
          <i class="fas fa-calendar-alt icon"></i>
          <span class="date">
            {{showDisplayRangeDate()}}
          </span>
        </div>
      </template>
    </date-range-picker>
  </div>
</template>

<script>
/* eslint vue/no-unused-vars: "off" */
// import _ from 'lodash';
import DateRangePicker from 'vue2-daterange-picker';
import dateFormatter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormatter],
  props: [
    'dateRange',
  ],
  components: {
    DateRangePicker,
  },
  data() {
    return {
      locale: {
        direction: 'ltr',
        format: 'DD-MM-YYYY',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        firstDay: 1,
        showWeekNumbers: true,
        daysOfWeek: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        monthNames: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
      },
    };
  },
  methods: {
    updateValues(data) {
      this.$emit('update:dateRange', {
        startDate: data.startDate,
        endDate: data.endDate,
      });
    },
    showDisplayRangeDate() {
      if (this.isSameDay(this.dateRange.startDate, this.dateRange.endDate)) {
        return `${this.formatDate(this.dateRange.startDate)}`;
      }
      return `${this.formatDate(this.dateRange.startDate)} - ${this.formatDate(this.dateRange.endDate)}`;
    },
  },
};
</script>

<style lang="scss" >
@import '~vue2-daterange-picker/dist/vue2-daterange-picker.css';
@import '@/assets/scss/variables.scss';

.date-range-picker-container {
  .reportrange-text {
    border-color: $gray-300;
    height: 40px;

    display: flex;
    align-items: center;

    min-width: 220px;
  }
}

.input-range-picke-container {
  .icon {
    margin-right: $spacer * 0.25;
  }
}
</style>
